import Typography from '@material-ui/core/Typography';
import FlightIcon from '@material-ui/icons/Flight';
import Timeline from '@material-ui/lab/Timeline';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import React from 'react';

export default function TrackingDetail({ details }) {
  return (
    <React.Fragment>
      <Typography color="textSecondary" gutterBottom>
        Detalle de eventos
      </Typography>
      <Timeline>
        {details.map(({ fecha, titulo, subtitulo }, index) => (
          <TimelineItem>
            <TimelineOppositeContent style={{ flex: 'none' }}>
              <Typography color="textSecondary">
                {fecha.split(' ')[0]}
              </Typography>
              <Typography color="textSecondary" style={{ fontSize: 12 }}>
                {fecha.split(' ')[1]}
              </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot variant="outlined">
                <FlightIcon
                  style={{ fontSize: 16, transform: 'rotate(180deg)' }}
                />
              </TimelineDot>
              {index !== details.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent>
              <Typography>{titulo}</Typography>
              <Typography color="textSecondary">{subtitulo}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </React.Fragment>
  );
}
